export default "__VITE_ASSET__5416880c__"